var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('BreadCrumbs',{attrs:{"breadcrumbs":_vm.breadcrumbs}}),_c('div',{class:_vm.$style.header,style:({
      'align-items': _vm.headerAlign
    })},[_vm._t("header")],2),_c('div',{class:_vm.$style.body},[_vm._t("body")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }